// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import Vuex from 'vuex'
import store from '@/store'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import JsonExcel from 'vue-json-excel'

// config
export const globalStore = new Vue({
  data: {
    API_BASE_URL: 'https://amica-group.bg/5yearwarranty/api/public/index.php/',
    RESOURCES_DIR: '../uploads/promotions/',

    //API_BASE_URL: 'http://dev.vmrhost.net/tests/amica/export-promotions/api/public/',
    //RESOURCES_DIR: 'uploads/promotions/'

    //API_BASE_URL: 'http://localhost:8000/',

    //API_BASE_URL: 'http://localhost/svn/www/amica-www/branches/export-promotions/api/public/',
    //RESOURCES_DIR: 'uploads/promotions/'

    // API_BASE_URL: 'https://api-5yearwarranty-amica-pl.dev5.pl/'
  }
})

// axios configuration
// axios.defaults.headers.common['Implementation-Id'] = globalStore.data.IMPLEMENTATION_ID
if (store.getters.isUserLoggedIn) {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + store.getters.getAuthToken
}

Vue.use(Vuex)
Vue.use(BootstrapVue)
Vue.use(VueAxios, axios)
Vue.component('downloadExcel', JsonExcel)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  },
  mounted () {
    // if (this.$store.getters.getImplementationsList.length === 0 && this.$store.getters.isUserLoggedIn) {
    //   this.$store.dispatch('fetchImplementationsList')
    // }
  }
});
